module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/nointernet.a62d2922.png";